export function YellowCardIcon({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 40 56"
			className={className}
			role="img"
			aria-label="Cartão amarelo"
		>
			<rect x="2" y="2" width="36" height="52" rx="4" fill="#f5d700" />
		</svg>
	)
}
